import { render, staticRenderFns } from "./InteractiveVideo.vue?vue&type=template&id=0bc8bcd4&scoped=true&"
import script from "./InteractiveVideo.vue?vue&type=script&lang=js&"
export * from "./InteractiveVideo.vue?vue&type=script&lang=js&"
import style0 from "./InteractiveVideo.vue?vue&type=style&index=0&id=0bc8bcd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc8bcd4",
  null
  
)

export default component.exports